import "./ParticipantDataSalesTable.css";
import { ParticipantSalesDataTableResponse } from "../../../Interfaces/TeamAdminCoordDashboard";
import { useState, useEffect } from "react";

interface ParticipantSalesDataTableDisplayProps {
  total_sales_data: ParticipantSalesDataTableResponse[];
  width: number;
  height: number;
  // max_entries_on_page?: number;
  one_col: boolean;
}

const ParticipantSalesDataTable: React.FC<
  ParticipantSalesDataTableDisplayProps
> = ({ total_sales_data, width, height, one_col }) => {
  const [fontSize, setFontSize] = useState(12); // Default font size

  useEffect(() => {
    // Update the circle radius dynamically based on container width
    const updateFontSize = () => {
      if (width > 0 && height > 0) {
        const div_extra = one_col ? 2 : 1; //div by extra 2 if we are just one column
        const newFontSize = Math.max(width / 16 / div_extra, 6); // Set a minimum font size of 12
        setFontSize(newFontSize);
      }
    };

    // update on component mount or when width/height changed
    updateFontSize();
  }, [total_sales_data, width, height]);

  return (
    <div className="team-admin-dashboard-participant-data-container">
      <div className="team-admin-dashboard-participant-data-scrollable">
        <table className="team-admin-dashboard-participant-data-table">
          <thead className="team-admin-dashboard-participant-data-thead">
            <tr>
              <th
                className="team-admin-dashboard-participant-data-th"
                style={{ fontSize: fontSize * 0.7 }}
              >
                Participant Name
              </th>
              <th
                className="team-admin-dashboard-participant-data-th"
                style={{ fontSize: fontSize * 0.7 }}
              >
                Primary Division
              </th>
              <th
                className="team-admin-dashboard-participant-data-th"
                style={{ fontSize: fontSize * 0.7 }}
              >
                Secondary Division
              </th>
              <th
                className="team-admin-dashboard-participant-data-th"
                style={{ fontSize: fontSize * 0.7 }}
              >
                # Items Sold
              </th>
              <th
                className="team-admin-dashboard-participant-data-th"
                style={{ fontSize: fontSize * 0.7 }}
              >
                Total Sales ($)
              </th>
              <th
                className="team-admin-dashboard-participant-data-th"
                style={{ fontSize: fontSize * 0.7 }}
              >
                Total Profit ($)
              </th>
            </tr>
          </thead>
          <tbody className="team-admin-dashboard-participant-data-tbody">
            {total_sales_data.map((participant_info, index) => (
              <tr key={index}>
                <td
                  className="team-admin-dashboard-participant-data-td"
                  style={{ fontSize: fontSize * 0.8 }}
                >
                  {participant_info.participant_name}
                </td>
                <td
                  className="team-admin-dashboard-participant-data-td"
                  style={{ fontSize: fontSize * 0.8 }}
                >
                  {participant_info.primary_div}
                </td>
                <td
                  className="team-admin-dashboard-participant-data-td"
                  style={{ fontSize: fontSize * 0.8 }}
                >
                  {participant_info.secondary_div}
                </td>
                <td
                  className="team-admin-dashboard-participant-data-td"
                  style={{ fontSize: fontSize * 0.8 }}
                >
                  {participant_info.num_items_sold}
                </td>
                <td
                  className="team-admin-dashboard-participant-data-td"
                  style={{ fontSize: fontSize * 0.8 }}
                >
                  ${participant_info.total_sales.toFixed(2)}
                </td>
                <td
                  className="team-admin-dashboard-participant-data-td"
                  style={{ fontSize: fontSize * 0.8 }}
                >
                  ${participant_info.total_profit.toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ParticipantSalesDataTable;
